import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MessageSquareText } from "lucide-react";
import { cn } from "@/lib/utils";

export function GlobalNavigation() {
  const { t } = useTranslation();
  return (
    <nav aria-label="グローバルメニュー" className="shrink-0 space-y-1 border-t p-2">
      {[
        { to: "/contact", labelKey: "sidebar.contact", icon: MessageSquareText },
      ].map((item) => (
        <NavLink key={item.to} to={item.to} className={({ isActive }) => cn(
          "flex items-center gap-3 rounded-md border-l-2 px-3 py-2 text-sm font-medium transition-colors",
          isActive ? "border-primary bg-accent text-accent-foreground" : "border-transparent text-muted-foreground hover:bg-accent hover:text-accent-foreground",
        )}>
          <item.icon className="h-4 w-4 shrink-0" aria-hidden="true" />
          <span className="sidebar-label">{t(item.labelKey)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
